import { Link, useContents } from "@appiodev/xcore-client/xcore-ui";
import { Relation } from "@appiodev/xcore-core";
import { Box, Flex, Icon, Stack } from "@xcorejs/ui";
import ViewIcon from "components/icons/16/view.svg";
import FormControl from "design-system/xcore/Form/FormControl";
import Select from "design-system/xcore/Select";
import { FC, useEffect, useState } from "react";
import { useLayout } from "xcore";
import { Products } from "xcore/types";

import { useProductFilters } from "./useProductFilters";

const ProductFilters: FC = ({ ...props }) => {
  const { stringify, value } = useLayout();
  const [[products]] = useContents<[any, Products]>();
  const { values, options, onChange } = useProductFilters();
  const [isDocumentReady, setIsDocumentReady] = useState<boolean>(false);

  useEffect(() => {
    if (document) {
      setIsDocumentReady(true);
    }
  }, []);

  return (
    <Box mt="3rem" {...props}>
      <Stack direction={{ _: "column", md: "row" }} gap={{ _: "1.5rem", sm: "3rem" }}>
        <Box width="100%" position="relative" role="group">
          <Box id="product_type_box" position="relative">
            <FormControl
              labelText={stringify(products.values.leftLabelName)}
            >
              <Select
                isMulti
                placeholder={stringify(products.values.leftPlaceholderText)}
                value={values["product-type"]}
                options={options["product-type"]}
                onChange={onChange("product-type")}
                menuPortalTarget={isDocumentReady ? document.getElementById("product_type_box") : null}
                styles={{
                  menuPortal: (styles: any) => ({
                    ...styles,
                    zIndex: 999999,
                    top: "8.9rem",
                    left: 0
                  })
                }}
              />
            </FormControl>

            <BrowseAllLink relation={value(products.values.middlePageProductType)} />
          </Box>
        </Box>

        <Box width="100%" position="relative" role="group">
          <Box id="product_size_box" position="relative">
            <FormControl labelText={stringify(products.values.midLabelName)}>
              <Select
                isMulti
                placeholder={stringify(products.values.midPlaceholderName)}
                value={values["product-size"]}
                options={options["product-size"]}
                onChange={onChange("product-size")}
                menuPortalTarget={isDocumentReady ? document.getElementById("product_size_box") : null}
                styles={{
                  menuPortal: (styles: any) => ({
                    ...styles,
                    zIndex: 999999,
                    top: "8.9rem",
                    left: 0
                  })
                }}
              />
            </FormControl>

            <BrowseAllLink relation={value(products.values.middlePageApplication)} />
          </Box>
        </Box>

        <Box width="100%" position="relative" role="group">
          <Box id="beam_type_box" position="relative">
            <FormControl labelText={stringify(products.values.rightLabelName)}>
              <Select
                isMulti
                placeholder={stringify(products.values.rightPlaceholderText)}
                value={values["beam-type"]}
                options={options["beam-type"]}
                onChange={onChange("beam-type")}
                menuPortalTarget={isDocumentReady ? document.getElementById("beam_type_box") : null}
                styles={{
                  menuPortal: (styles: any) => ({
                    ...styles,
                    zIndex: 999999,
                    top: "8.9rem",
                    left: 0
                  })
                }}
              />
            </FormControl>

            <BrowseAllLink relation={value(products.values.middlePageBeamType)} />
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default ProductFilters;

const BrowseAllLink: FC<{ relation: Relation }> = ({ relation }) => {
  const { stringify } = useLayout();
  const [[products]] = useContents<[any, Products]>();

  return (
    <Box position="absolute" right={0} top="0.2rem" overflow="hidden">
      <Flex
        transform={{ _: "", md: "translateX(calc(100% - 1.6rem))" }}
        transition="transform 300ms"
        _group={{ _hover: { transform: "translateX(0)" } }}
      >
        <Icon
          svg={<ViewIcon />}
          fill="gray"
          mr="0.9rem"
          display={{ _: "none", md: "block" }}
          _group={{ _hover: { _icon: { fill: "robe" } } }}
        />

        <Link
          variant="underline"
          content={relation}
          lineHeight="1.5rem"
          position="relative"
          overflow="hidden"
          opacity={{ _: 1, md: 0 }}
          transition="opacity 300ms"
          _group={{ _hover: { opacity: 1 } }}
        >
          {stringify(products.values.browseAllBtn)}
        </Link>
      </Flex>
    </Box>
  );
};
